import { render, staticRenderFns } from "./LtiLaunchForm.vue?vue&type=template&id=0dea239a"
import script from "./LtiLaunchForm.vue?vue&type=script&lang=js"
export * from "./LtiLaunchForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports